import { CandidatePriority } from '../candidate';

export enum AutomaticMatchesErrors {
  EmployerHasAutomaticMatchesDisabled = 'Employer does not have automatic matches enabled',
  CandidateDocument = 'Candidate document mismatch',
  OldDetailedCandidateDocument = 'Old detailed Candidate document mismatch',
  NewFileExistsCandidateDocument = 'New file exists Candidate document mismatch',
  NoDocumentExistsCandidateDocument = 'No document exists Candidate document mismatch',
  NotDetailedCandidateDocument = 'Not detailed Candidate document mismatch',
  CandidateDrivers = 'Candidate does not have a driver license',
  CandidateMarginalEmployment = 'Candidate wants marginal employment',
  CandidateEmploymentType = 'Candidate employment type mismatch',
  CandidateNightShift = 'Candidate wants only night shift',
  CandidateParentShift = 'Candidate wants only parent shift',
  CandidateShiftRequirement = 'Candidate does not match the shift requirement',
  CandidateGender = 'Candidate gender mismatch',
  CandidateDisallowedJobTitle = 'Candidate has a disallowed job title as desired',
  CandidateJobPositionMismatch = 'Candidate job titles do not match job position',
  CandidateInconsistentJobTitles = 'Candidate has inconsistent job titles',
  CandidateIncompleteJobPosition = 'Candidate has incomplete job position',
  CandidatePriorityQualifications = 'Candidate does not have qualifications for priority',
  CandidateProfessionalSuitability = 'Candidate professional suitability mismatch',
  CandidateExperience = 'Candidate experience is not enough for role',
  CandidateCompanion = 'Candidate is a companion without the correct qualifications',
  CandidateRegisterMethod = 'Candidate registered as transparent or multiposting candidate',
  CandidateGhosted = 'Candidate is ghosted',
  CandidateInactive = 'Candidate is not active',
  JobPositionInactive = 'Job position is not published',
  OtherHotHotCaseMatch = 'Candidate has another HotCase matches',
  TooManyActiveMatches = 'Candidate has too many active matches',
  CandidateGermanSpeakingLevel = 'Candidate does not speak German',
  CandidateNaeInRecognition = 'Candidate does has NAE in recognition',
  CandidateChat = 'Candidate has chat on match',
  NotFirstMatch = 'Not the first match between candidate and organisation',
  MatchInvalidOnlineMatchStatus = 'The match has invalid online match status',
  AssistantNurseQualificationChecksLg = 'Assistant nurse qualification checks failed for LG Training',
  AssistantNurseQualificationChecksNae = 'Assistant nurse qualification checks failed for NAE',
  JobPositionDisallowedJobTitle = 'Job position has disallowed job title',
  CandidateBlacklisted = 'Candidate is blacklisted',
  StrictOneYearTrainingOrTwoYears = `"${CandidatePriority.D2}" job position found when strict one year training or two years is required`,
  TestCandidate = 'Candidate is a test candidate',
  DociaOfflineMatch = 'Match is a Docia offline match',
}
